// extracted by mini-css-extract-plugin
export default {"FloatingActionButton":"FloatingActionButton_FloatingActionButton__Jq66q"};